import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { DialogDefaultV2 } from '../../../components/v2';
import { LEGENDA_CLASSIFICACAO, labelSeveridade, labelTipo } from './constants';

const corSeveridade = (severidade) => {
  if (severidade === 'ALTA') return 'error';
  if (severidade === 'MEDIA') return 'warning';
  return 'default';
};

const LegendaClassificacaoDialog = ({ open, onClose }) => (
  <DialogDefaultV2
    open={open}
    handlerCancel={onClose}
    handlerConfirm={onClose}
    title="O que significa cada classificação"
    readOnly
    maxWidth="md"
    fullWidth
  >
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Classificação</TableCell>
          <TableCell>Severidade</TableCell>
          <TableCell>Significa</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {LEGENDA_CLASSIFICACAO.map((item) => (
          <TableRow key={item.codigo}>
            <TableCell sx={{ verticalAlign: 'top', minWidth: 180 }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>{labelTipo(item.codigo)}</Typography>
            </TableCell>
            <TableCell sx={{ verticalAlign: 'top' }}>
              <Stack spacing={0.5} alignItems="flex-start">
                <Chip size="small" label={labelSeveridade(item.severidade)} color={corSeveridade(item.severidade)} />
                {item.severidadeNota && (
                  <Typography variant="caption" color="text.secondary">{item.severidadeNota}</Typography>
                )}
              </Stack>
            </TableCell>
            <TableCell sx={{ verticalAlign: 'top' }}>{item.significa}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </DialogDefaultV2>
);

LegendaClassificacaoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LegendaClassificacaoDialog;
